import { useMutation } from '@apollo/client';
import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import { ERRORS } from 'constants/notify';
import React, { useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { JOIN_CHAT } from 'services/graphql/mutations/chatRoom';
import { GeneralFunction } from 'types/common';
import { IChatRoom } from 'types/messages';
import { defaultNotification } from 'utils';

const JoinAppointmentChat: React.FC<{ chatRoom?: IChatRoom; callback?: GeneralFunction }> = ({
  chatRoom,
  callback,
}) => {
  const [alertVisible, setAlertVisible] = useState(false);

  const [joinChatRoom, { loading }] = useMutation(JOIN_CHAT);

  const confirmJoinChatRoom = async () => {
    try {
      await joinChatRoom({ variables: { roomId: chatRoom?.id } });
      callback?.();
    } catch (err) {
      defaultNotification({ failure: ERRORS.DEFAULT_MUTATION_ERROR });
    } finally {
      setAlertVisible(false);
    }
  };
  const onJoinAppointmentThreadClick = () => {
    setAlertVisible(true);
  };
  const hideLeaveAppointmentAlert = () => {
    setAlertVisible(false);
  };

  return (
    <div className='w-full h-full p-4'>
      <ButtonWithSpinner isLoading={loading} width='auto' onClick={onJoinAppointmentThreadClick}>
        Join Appointment Thread
      </ButtonWithSpinner>
      <SweetAlert
        show={alertVisible}
        warning
        showCancel
        confirmBtnText='Join'
        confirmBtnBsStyle='info'
        cancelBtnText='Cancel'
        title='Join this appointment thread?'
        onConfirm={confirmJoinChatRoom}
        onCancel={hideLeaveAppointmentAlert}
        focusConfirmBtn
      />
    </div>
  );
};

export default React.memo(JoinAppointmentChat);
